<template>
  <div class="app" style="margin-top: 10px">
    <el-steps :active="active" align-center class="steps" finish-status="success">
      <el-step title="基础信息"></el-step>
      <el-step title="证件信息"></el-step>
      <!-- <el-step title="协议合同"></el-step> -->
      <el-step title="建店成功"></el-step>
    </el-steps>
    <step1 v-if="active === 1" @change-step="handleSetStep" ></step1>
    <step2 v-if="active === 2" :info-data="registeInfo" :stepShopId="shopId11" @change-step="handleSetStep"></step2>
    <step3 v-if="active === 3" @change-step="handleSetStep" :stepShopId="shopId11"></step3>
    <!-- <step4 v-if="active === 4" :info-data="registeInfo" @change-step="handleSetStep"></step4> -->
  </div>

</template>

<script>
import Step1 from '@/views/jdstoreRegister/jdbaseInfoRegister'
import Step2 from '@/views/jdstoreRegister/jdcredInfoRegister'
import Step3 from '@/views/jdstoreRegister/jddeptRegister'
// import Step4 from '@/views/storeRegister/deptRegister'
export default {
  components: {
    Step1,
    Step2,
    Step3
    // Step4
  },
  data () {
    return {
      active: 1,
      registeInfo: {},
      shopId11: ''
    }
  },
  methods: {
    handleSetStep (active, id) {
      console.log("=====跳转后获取上step值",id)
      this.shopId11 = id
      this.active = active

    },

  }
}
</script>

<style>
.app{
  height: 100%;
}
/* .steps{
  position: fixed;
  margin-top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
} */
</style>



// WEBPACK FOOTER //
// src/views/jdstoreRegister/jdcenter.vue